module.exports = __webpack_public_path__ + "static/orioles-logo-8b75c2e0691fa496c3515960b498c41d.png";